import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a user is in the depleted state and views the warning',
  name: 'depleted_state_viewed',
  params: [
    {
      description: 'The surface where the depleted state warning was viewed',
      name: 'surface',
      required: true,
      type: 'enum',
      values: ['upload_modal', 'canvas', 'banner'],
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
